var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIco24FooterReddit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 3.5a8.5 8.5 0 1 1 0 17 8.5 8.5 0 0 1 0-17zm3.55 3.36a.86.86 0 0 0-.786.497l-2.058-.437c-.06-.01-.12 0-.17.03-.049.03-.079.08-.099.139l-.626 2.962c-1.322.04-2.505.428-3.36 1.054a1.254 1.254 0 0 0-.855-.348 1.243 1.243 0 0 0-.507 2.376c-.02.12-.03.249-.03.378 0 1.909 2.217 3.45 4.96 3.45 2.745 0 4.962-1.541 4.962-3.45 0-.13-.01-.248-.03-.368.407-.199.716-.636.716-1.143 0-.686-.557-1.243-1.243-1.243-.338 0-.636.13-.855.348-.845-.606-2.018-1.004-3.31-1.054l.566-2.654 1.84.388a.886.886 0 0 0 1.769-.04.887.887 0 0 0-.885-.885zm-1.423 8.033c.07.1.07.239-.02.328-.606.606-1.759.646-2.097.646-.338 0-1.501-.05-2.098-.646a.234.234 0 0 1 0-.328c.09-.09.239-.09.328 0 .378.378 1.193.517 1.78.517.586 0 1.392-.14 1.78-.517.089-.09.238-.09.327 0zM10.051 12c.488 0 .885.398.885.885a.887.887 0 0 1-.885.885.887.887 0 0 1-.884-.885c0-.487.397-.885.884-.885zm3.898 0c.487 0 .884.398.884.885a.887.887 0 0 1-.884.885.887.887 0 0 1-.885-.885c0-.487.397-.885.885-.885z",
    fill: "#999",
    fillRule: "nonzero"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIco24FooterReddit);
export default __webpack_public_path__ + "static/media/ico-24-footer-reddit.4bddad66.svg";
export { ForwardRef as ReactComponent };